<template>
    <section class="custom-container">
      <h1 class="mt-4 font-xl font-bold text-center">{{texts.title}}</h1>
      <p class="text-center mt-1">
        {{texts.description}}
      </p>
      <div class="form-row mt-2">
        <div class="form-group-row" v-for="item in parcelList" :key="item.name">
          <label class="align-content-center">
            <img class="img-parcel" :src="`/storage/img/${item.name.toLowerCase()}.jpeg`" :alt="utils.getParcelLabel(item.name)">
          </label>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  import utils from '../../composables/utils';
  export default {
    props: {
      parcelList: {
        type: Array,
        required: true
      },
      texts: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        utils,
        /* allParcels: [
            { value: "PAQUETEXPRESS", label: "PAQUETEXPRESS", inputId: "chbox-paquetexpress", img: "paquetexpress" },
            { value: "FEDEX", label: "FEDEX", inputId: "chbox-fedex", img: "fedex" },
            { value: "DHL", label: "DHL", inputId: "chbox-dhl", img: "dhl" },
            { value: "ESTAFETA", label: "ESTAFETA", inputId: "chbox-estafeta", img: "estafeta" }
        ]  */
      }
    },
    methods: {

    }
  };
  </script>
